import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ReadingPictureView } from './ReadingPictureView';
import { ReadingPictureListAll } from './ReadingPictureListAll';


export const ReadingPicturePage = ()=>{    
    return (
        <div className="bookReportPage">
            <Routes>
                <Route path="/" element={ <ReadingPictureListAll /> } /> 
                <Route path="/view/:id" element={ <ReadingPictureView /> } /> 
            </Routes>
        </div>
    );
};